import * as THREE from 'three'
import * as SkeletonUtils from 'three/examples/jsm/utils/SkeletonUtils.js';
import Experience from "../Experience"

export default class Boat {
    constructor(offset, color) {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.time = this.experience.time
        this.debug = this.experience.debug

        // Setup
        this.resource = this.resources.items.boatModel

        // Debug
        // if (this.debug.active) {
        //     this.debugFolder = this.debug.ui.addFolder('fish')
        // }

        // This offset for the dupe
        if (offset) { this.offset = offset } else { this.offset = 50 }
        // This color for the dupe
        if (color) { this.color = color } else { this.color = null }

        this.setModel()
        // this.setTextures()
        this.setAnimation()
        this.setMaterial()

        // Bind the method to the instance, otherwise the eventlistener uses the DOM element to look for the method which is wrong
        // this.switchAnimation = this.switchAnimation.bind(this)

        // this.addEventListeners()

    }

    // Check if hotspot is clicked
    addEventListeners() {
        // window.addEventListener('click', (event) => document.querySelectorAll('.point-fish')[0].switchAnimation(), false);
        // document.querySelectorAll('.point-fish')[0].addEventListener('click', this.switchAnimation)
        // document.querySelectorAll('.point-fish')[0].parentElement.querySelector('.close').addEventListener('click', this.switchAnimation)
    }

    setModel() {
        this.model = SkeletonUtils.clone(this.resource.scene);
        // this.model = this.resource.scene
        this.model.position.set(0, -.0300, 0)
        this.scene.add(this.model)

        this.model.traverse((child) => {
            if (child instanceof THREE.Mesh) {
                // child.material.clone();
                child.receiveShadow = false // Prevents weird shadows on top of boat
                child.castShadow = true
            }
            // Basically clone the meshes' materials since there are multiple meshes, not just one.
            if (Array.isArray(child.material)) {
                child.material = child.material.map((m) => m.clone());
            } else if (child.material) {
                child.material = child.material.clone();
            }
        })

        // after: this.model = SkeletonUtils.clone(resource.scene);
        // this.model.traverse((o) => {
        //     if (!o.isMesh) return;

        //     // ensure this instance has its *own* material(s)
        //     if (Array.isArray(o.material)) {
        //         o.material = o.material.map((m) => m.clone());
        //     } else if (o.material) {
        //         o.material = o.material.clone();
        //     }
        // });

    }

    setMaterial() {
        if (this.color !== undefined && this.color !== null) {
            this.model.children[0].children[0].children[0].material.color.set(this.color)
        }

        // this.model.traverse((child) => {
        //     if (child instanceof THREE.Mesh) {
        //         child.material = new THREE.MeshBasicMaterial({ map: child.material.map })
        //     }
        // })
        // let m = this.model.children[0].material

        // if (m) {
        //     m.dispose()
        // }

        // // m.visible = false
        // m = new THREE.MeshStandardMaterial({
        //     color: 0xffffff,
        //     envMap: null,
        //     map: null,
        // })
        // m.needsUpdate = true;
    }
    // setTextures() {
    //     this.textures = {}
    //     this.textures.color = this.resources.items.fishTexture
    //     this.textures.color.colorSpace = THREE.SRGBColorSpace
    //     this.textures.color.repeat.set(1.5, 1.5)
    //     this.textures.color.wrapS = THREE.RepeatWrapping
    //     this.textures.color.wrapT = THREE.RepeatWrapping

    //     this.textures.normal = this.resources.items.grassNormalTexture
    //     this.textures.normal.repeat.set(1.5, 1.5)
    //     this.textures.normal.wrapS = THREE.RepeatWrapping
    //     this.textures.normal.wrapT = THREE.RepeatWrapping
    // }

    setAnimation() {
        this.animation = {}
        this.animation.mixer = new THREE.AnimationMixer(this.model)

        this.animation.actions = {}

        this.animation.actions.path = this.animation.mixer.clipAction(this.resource.animations[0])

        this.animation.actions.current = this.animation.actions.path
        this.animation.actions.current.play()
        this.animation.actions.current.time = this.offset
    }

    update() {

        this.animation.mixer.update(this.time.delta / 2000) // Divide by 1000 because it's in milliseconds
    }
}